/// <amd-module name="Environments/EnvironmentsSecurity/Actions/EnvironmentsSecurityActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { EnvironmentInstance } from "DistributedTask/Client/Contracts/TaskAgent";

export class EnvironmentSecurityActions extends ActionsHubBase {

    public static getKey(): string {
        return "environments-security-actions";
    }

    public initialize(instanceId?: string) {
        this._setEnvironment = new Action<EnvironmentInstance>();
    }

    public get setEnvironment(): Action<EnvironmentInstance> {
        return this._setEnvironment;
    }

    private _setEnvironment: Action<EnvironmentInstance>;
}
